import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

function MdiIcon(props: SvgIconProps & { d: string }) {
    const { d, ...rest } = props;
    return (
        <SvgIcon {...rest}>
            <path d={d} />
        </SvgIcon>
    );
}

export default MdiIcon;
